import { Entity } from "@cayo/shared/api/types/cayo-graph";
import { appEvents } from "@cayo/shared/components/App/appEvents";

export const updateProps = (gridId: string, objects?: Entity[]) => {
  appEvents.trigger({ updateProps: { id: gridId, objects } });
};
